.page { position: fixed; inset: 0; display: flex; align-items: center; justify-content: center; gap: 12px; font-size: 15px; }
.reload { border: 0; border-radius: 999px; padding: 6px 14px; background: var(--accent); color: var(--on-color); font-weight: 600; }
.region { padding: 12px 16px; font-size: 13px; color: var(--muted); }
